import React, { useState} from 'react'
import shareVideo from '../assets/share.mp4';
import logo from '../assets/logowhite.png';
// import { TransactionContext } from "../context/TransactionContext";
import { useNavigate } from 'react-router-dom';
import { client } from '../client';
// import { v4 as uuidv4 } from 'uuid';
// import {ethers} from 'ethers';

const {ethereum} = window;

const Login = () => {
  const navigate = useNavigate();
  const [x, setX] = useState('Connect Wallet')
  const [currentAccount, setCurrentAccount] = useState('');

  // const checkIfWalletIsConnected = async () => {
  //   try {
  //       if(!ethereum) return alert("Please install MetaMask");

  //       const accounts = await ethereum.request({method: 'eth_accounts'});

  //       if(accounts.length) {
  //           setCurrentAccount(accounts[0]);
  //       }else{
  //           console.log('No accounts found');
  //       }
        
  //   } catch (error) {
  //       console.log(error);

  //       throw new Error("No ethereum object.")
  //   }

    

    
// }

const connectWallet = async () => {
    try{
        if(!ethereum) return alert("Please install MetaMask");

        const accounts = await ethereum.request({method: 'eth_requestAccounts'})

        setCurrentAccount(accounts[0]);

        console.log(accounts[0])

        let id = accounts[0].slice(accounts[0].length-3)
        console.log(id)

        const query = `*[_type=="user" && userName == "${currentAccount}"]`
        client.fetch(query).then(res => {
            if(res.length===0){
                localStorage.setItem('user', id);
                const doc = {
                  _id: id.toString(),
                  _type: 'user',
                  userName:accounts[0],
                  image: 'https://picsum.photos/200'
                }
                client.createIfNotExists(doc)
                navigate('/login', { replace: true });
                setX('Login')
            } else {
                navigate('/', { replace: true });
                // setX('Login')  
            }
        })
        
    } catch(err){
        console.log(err);

        throw new Error("No ethereum object.")
    }
}
  

  return (
    <div className="flex justify-start items-center flex-col h-screen">
      <div className=" relative w-full h-full">
      
        <video
          src={shareVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className="w-full h-full object-cover"
        />
        <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0  bg-blackOverlay">
          <div className="p-5">
            <img src={logo} width="130px" alt="logo" />
          </div>
          <div className="shadow-2xl">
            {(<button
                type="button"
                onClick={connectWallet}
                className="flex flex-row justify-center items-center my-5 bg-[#2952e3] p-3 rounded-full cursor-pointer hover:bg-[#2546bd]"
                >
                <p className="text-white text-base font-semibold">{x}</p>
              </button>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login